// Temporary mirror of critical payment events to a Google Sheet via Apps
// Script, so they are visible without querying the logger backend. Public
// unauthenticated endpoint: remove once the backend forwards these events.
const MIRROR_URL = "https://script.google.com/macros/s/AKfycbxdIudKpnSGW3G6Ub2IaCrE3rPn3eqlODoRDOVnT_BIL7RpcMLH2JKHx8dLiICjGBJqig/exec";

// Everything that happens to an order and its payment, so the sheet can be
// reconciled against the dashboard. Browsing telemetry stays out: it would
// bury these rows and burn the Apps Script quota.
const MIRROR_ACTIONS = [
    "order_sent",
    "order_post_failed",
    "order_post_expired",
    "stripe_pending_recovered",
    "stripe_pending_mismatch",
    "stripe_confirm_recovered",
    "stripe_outcome_unknown",
    "stripe_payment_failed",
];

function mirrorLog(risId, action, metadata) {
    if (!MIRROR_ACTIONS.includes(action)) {
        return;
    }

    try {
        const body = JSON.stringify({
            "ts": new Date().toISOString(),
            "ris_id": risId,
            "action": action,
            ...metadata,
        });

        // keepalive survives the redirect/page close that follows these
        // events, like sendBeacon would, but content blockers filter the
        // beacon request type. The plain string body avoids a CORS preflight.
        if (window.fetch) {
            window.fetch(MIRROR_URL, { method: "POST", mode: "no-cors", keepalive: true, body: body }).catch(console.error);
        } else if (navigator.sendBeacon) {
            navigator.sendBeacon(MIRROR_URL, body);
        }
    } catch (err) {
        console.error(err);
    }
}

const logmirror = {
    mirrorLog,
};
export default logmirror;
